export default __webpack_public_path__ + "static/media/background-hero.d3620aa5.svg";